import { Component, Inject, OnInit } from '@angular/core';

import { AnnouncementsNotificatorBase, PreparingDataNotificatorBase } from '@skylab-shared/business';

import { AnnouncementsNotificator, PreparingDataNotificator } from '@skylab-angular-shared/business';
import { TranslatePipe } from '@skylab-angular-shared/pipes';
import { IconComponent } from '@skylab-angular-shared/ui';
import { AnnouncementContentKind } from '@skylab-shared/dataModel';

@Component({
    selector: 'skl-preparing-data-announcement',
    template: `
        @if (show) {
            <skl-icon name="info"></skl-icon>
            <p>{{'scenes.announcements.preparing-data' | translate}}</p>
        }
    `,
    styles: [`
        :host {
            display: flex;
            align-items: center;
            color: var(--text-color-light);
            padding-inline: var(--gutter-big);
            background-color: var(--info-color);

            skl-icon {
                margin-right: var(--gutter-small);
            }

            p {
                line-height: 1.5;
                margin-block: var(--gutter-small);
            }
        }
    `],
    imports: [TranslatePipe, IconComponent]
})
export class PreparingDataAnnouncementComponent implements OnInit {
    public show = false;

    public constructor(
        @Inject(PreparingDataNotificator) private readonly preparingDataNotificator: PreparingDataNotificatorBase,
        @Inject(AnnouncementsNotificator) private readonly announcementNotificator: AnnouncementsNotificatorBase
    ) { }

    public ngOnInit(): void {
        this.prepareAnnouncement();
        this.preparingDataNotificator.addObserver(() => {
            this.announcementNotificator.refreshAsync().then(() => {
                this.prepareAnnouncement();
            });
        });
    }

    private prepareAnnouncement(): void {
        const announcements = this.announcementNotificator.getAnnouncements();
        this.show = !!announcements.find(elem => JSON.parse(elem.content)?.Kind === AnnouncementContentKind.BackgroundDataPreparationPending);
    }
}
